import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=1ed93962&scoped=true&"
import script from "./WorkingHours.vue?vue&type=script&lang=js&"
export * from "./WorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHours.vue?vue&type=style&index=0&id=1ed93962&lang=scss&scoped=true&"
import style1 from "./WorkingHours.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed93962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed93962')) {
      api.createRecord('1ed93962', component.options)
    } else {
      api.reload('1ed93962', component.options)
    }
    module.hot.accept("./WorkingHours.vue?vue&type=template&id=1ed93962&scoped=true&", function () {
      api.rerender('1ed93962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/WorkingHours.vue"
export default component.exports